import ApexCharts from "apexcharts-clevision";
import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="chart"
export default class extends Controller {
  static values = {
    options: Object
  }

  connect() {
    let chart = new ApexCharts(this.element, this.optionsValue)
    chart.render();
  }
}
